import {PAGE_URL, PERMISSION_KEY} from "../services/constant";
const grantedUserMenuRegistry = {
    core_grantedUser: {
        label: "Granted Users",
        link: PAGE_URL.GRANTED_USER_PAGE,
        key: PAGE_URL.GRANTED_USER_PAGE,
        resourceKey: PERMISSION_KEY
    }
}

export default grantedUserMenuRegistry;
